import React from "react";
import NoDataFound from "../Common/NoDataFound";
import Badge from "react-bootstrap/Badge";
import {
  convertFirstLetterOfFullNameToCapital,
  customName,
  getColorFromId,
} from "../../helpers/commonHelpers";
import { useSelector } from "react-redux";
import Loader from "../Common/Loader";
import Alert from "../Common/Alert";

const MeetingAttendance = React.memo(() => {
  const meetingData = useSelector((state) => state.meeting);

  return (
    <div className="form-group agenda">
      <label className="mt-2 mb-3 add-agenda">
        <h4 className="mb-0">Meeting Attendance</h4>
      </label>
      <div className="mt-2 agenda-box-border attendees-popup-list">
        {meetingData.meetingDetails?.attendanceDetails?.length > 0 ? (
          <form className=" details-form details-form-right responsive-table tbl-2-responsive ">
            <table className="table table-striped attendance-tbl">
              <thead>
                <tr  className="text-align-center ">
                  <th scope="col">Sl. No</th>
                  <th scope="col">Attendee(s)</th>
                  <th scope="col">Status</th>
                  <th scope="col">Type</th>
                </tr>
              </thead>
              <tbody>
                {meetingData.meetingDetails?.attendanceDetails.length !== 0 ? (
                  <>
                    {meetingData.meetingDetails?.attendanceDetails.map(
                      (attendee, index) => {
                        const matchedAttendee =
                          meetingData.meetingDetails?.attendees?.find(
                            (a) => a.email === attendee.email
                          );

                        const attendeeId = matchedAttendee?._id || attendee._id;

                        return (
                          <tr key={index} >
                            <td
                              data-label="Sl. No."
                              className="blue-bold-text"
                              scope="row"
                            >
                              {index + 1}
                            </td>
                            <td data-label="Attendees">
                              <div className="attendees responsive-right">
                            
                              
                                 <div
                                  className="attendee-list"
                                  style={{
                                    backgroundColor: attendee?.profilePicture
                                      ? undefined
                                      : getColorFromId(attendeeId),
                                    borderRadius: "50px",
                                    
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minWidth: "32px",
                                    height: "32px",
                                  }}
                                >
                                  {attendee?.profilePicture ? (
                                    <img
                                      src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                                      alt=""
                                      className="attendee-profile-picture icon-image"
                                      style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                      }}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.style.display = "none";
                                        // e.target.parentElement.innerHTML = `<span class="attendee-name">${customName(
                                        //   attendee?.name
                                        // )}</span>`;
                                        // e.target.parentElement.style.backgroundColor =
                                        //   getColorFromId(attendeeId);
                                             e.target.parentElement.style.backgroundColor = getColorFromId(
                                                                               attendeeId
                                                                              );
                                                                              e.target.parentElement.innerText = customName(
                                                                                attendee.name
                                                                              );
                                      }}
                                    />
                                  ) : (
                                    <span className="attendee-name">{customName(attendee.name)}</span>
                                  )}
                                </div>

                                <div className="action-cmnt-text">
                                  <p className="detail-name word-break">
                                    {convertFirstLetterOfFullNameToCapital(
                                      attendee.name
                                    )}
                                  </p>

                                  <p className="name-undertext detail-date-time global-email-width">
                                    {attendee.email}
                                  </p>

                                  {meetingData?.meetingDetails
                                    ?.isAttendanceAdded &&
                                  attendee.isAttended === true ? (
                                    <p>
                                      <Badge bg="" className="badge-light-blue mr-2">
                                        {" "}
                                        {attendee?.fromTime}
                                      </Badge>
                                      -
                                      <Badge bg="" className="badge-light-blue ms-2">
                                        {" "}
                                        {attendee?.toTime}
                                      </Badge>
                                    </p>
                                  ) : null}
                                </div>
                              </div>
                            </td>
                            <td data-label="Status"  className="text-align-center ">
                              {meetingData?.meetingDetails?.isAttendanceAdded &&
                              attendee.isAttended ? (
                                <span className="badge Present-color">
                                  Present
                                </span>
                              ) : meetingData?.meetingDetails
                                  ?.isAttendanceAdded &&
                                attendee.isAttended === false ? (
                                <span className="badge Absent-color">
                                  Absent
                                </span>
                              ) : (
                                <span className="badge NA-color">NA</span>
                              )}
                            </td>

                            <td data-label="Type"  className="text-align-center ">
                              {attendee?.attendanceType === "PARTIAL" &&
                              attendee.isAttended === true ? (
                                <span className="badge Partial-color">
                                  Partial
                                </span>
                              ) : attendee?.attendanceType === "PARTIAL" &&
                                attendee.isAttended === false ? (
                                <span className="badge NA-color">NA</span>
                              ) : attendee?.attendanceType === "FULL" &&
                                attendee.isAttended === false ? (
                                <span className="badge NA-color">NA</span>
                              ) : (
                                <span className="badge Full-color">Full</span>
                              )}
                            </td>
                          </tr>
                        );
                      }
                    )}
                  </>
                ) : null}
              </tbody>
            </table>
          </form>
        ) : meetingData.meetingDetails?.attendanceDetails?.length === 0 &&
          !meetingData.loading ? (
          <div className="no-data-img mt-3">
            <Alert
              status={"info"}
              message={"No data available."}
              timeoutSeconds={0}
            />
            <NoDataFound dataType={"meetingActivities"} />
          </div>
        ) : (
          <div
            className="meeting-page "
            style={{ textAlign: "center", paddingTop: 20 }}
          >
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
});

export default MeetingAttendance;
